<template>
    <article class="section grid grid__all-around">
        <cmp-scroll-anchor class="section--anchor" :id="anchor"></cmp-scroll-anchor>

        <!-- <pre v-text="boundaries"></pre> -->
        <!-- <pre v-if="content" v-text="content"></pre> -->

        <h2 ref="title"
                class="section--title u-reset u-reset__h1"
                v-text="content.title">
        </h2>
        <div class="grid--row">
            <component class="section--col grid--col"
                    v-for="(plugin, pluginIdx) in plugins" :key="pluginIdx"
                    :is="plugin.type"
                    :plugin="plugin">
            </component>
        </div>
    </article>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';
    import sectionMixin from 'vue/mixins/section';



    export default {
        mixins: [
            cmsPlugin,
            sectionMixin,
        ],
    };
</script>



// WEBPACK FOOTER //
// index.vue?6991b9fe